require('./category-text-menu/category-text-menu.scss');
var Obscura = require('backbone.obscura');

var CategoryTextMenu = Backbone.Marionette.CompositeView.extend({
    className: 'fmcy-category-text-menu container-fluid',
    template: require('./category-text-menu/category-text-menu.html'),
    childView: require('./category-text-menu/category'),
    childViewContainer: '.fmcy-categories-text-menu-container',
    childViewOptions: function (categoryModel, index) {
        var self = this;
        return {
            appChannel: self.options._appChannel,
            model: categoryModel,
            categories: self.options.categories,
            collection: self.options.categories
        };
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                foo: 'bar',
                defaultMenuHeight: 150,
                _appChannel: null,
                categories: null,
                mode: 'default',
                parentCategorySlug: 'cannabis'
            }
        );
        this.menuHeight = this.options.defaultMenuHeight;
        this.collection = options.categories;

        var parent_id = this.collection.findWhere({slug: this.options.parentCategorySlug}).get('id');
        if (!parent_id) {
          parent_id = null;
        }

        var parentCollection = new Obscura(
            this.collection
        );
        parentCollection.filterBy('parent_id', function(model) {
          // top level
          if (model.get('parent_id') === parent_id) {
            model.set('level', 0);
            return true;
          } else {
            return false;
          }
        }).setSort('ordinal', 'asc');

        this.collection = parentCollection;
    },
    _initializeElements: function () {
      var self = this;
      this.$el.css('opacity', 0);
      this.collection.each(function(model) {
          var view = self.children.findByModel(model);
          if (view) {
              view.$el.css('opacity', 0);
          }
      });
    },
    _adjustMenuAlignment: function () {
      var self = this;

      var menu_width = this.$el.width();
      var totalColumns = 5;
      if ($(window).width() >= 1200) {
        totalColumns = 5;
      } else if ($(window).width() >= 1081) {
        totalColumns = 4;
      } else if ($(window).width() >= 700) {
        totalColumns = 3;
      } else if ($(window).width() >= 480) {
        totalColumns = 2;
      } else {
        totalColumns = 1;
      }
      var columnWidth = (menu_width / totalColumns);
      var menu_height = this.options.defaultMenuHeight;
      if (this.menuHeight !== this.options.defaultMenuHeight) {
        menu_height = this.menuHeight;
      }
      var currentRow = 1;
      var currentColumn = 1;
      var starting_y_pos = 25;
      var starting_x_pos = 50;
      var bottomPadding = 25;
      var totalOneColumnHeight = 0;
      var current_current_x_pos = starting_x_pos;
      var current_current_y_pos = starting_y_pos;

      this.collection.each(function(model) {
          var view = self.children.findByModel(model);

          if (view) {

              view.$el.css('top', current_current_y_pos + 'px');
              view.$el.css('left', current_current_x_pos + 'px');

              current_current_y_pos += view.getHeight();
              totalOneColumnHeight += view.getHeight();

              if (totalColumns !== 1) {
                if (current_current_y_pos > ((currentRow * menu_height) - bottomPadding)) {

                  currentColumn += 1;

                  if (currentColumn > totalColumns) {
                    currentRow += 1;
                    currentColumn = 1;
                  }

                  current_current_y_pos = ((currentRow - 1) * (menu_height)) + starting_y_pos;
                  current_current_x_pos = ((currentColumn - 1) * columnWidth) + starting_x_pos;

                  view.$el.css('top', current_current_y_pos + 'px');
                  view.$el.css('left', current_current_x_pos + 'px');
                  current_current_y_pos += view.getHeight();
                }
              }
          }

      });

      if (totalColumns !== 1) {
        menu_height = (menu_height * currentRow);
      } else {
        menu_height = totalOneColumnHeight;
      }

      if (menu_height > this.menuHeight) {
        this.menuHeight = menu_height;
        this._adjustMenuAlignment();
      } else {
        this.$el.height(menu_height + 150);
        this.$el.css('opacity', 1);
        var viewCount = 0;
        this.collection.each(function(model) {
            viewCount += 1;
            var view = self.children.findByModel(model);
            if (view) {
              view.$el.css('opacity', 1);
            }
        });
      }
    },
    _onWindowResize: function (event) {
      this.menuHeight = this.options.defaultMenuHeight;
      this._adjustMenuAlignment();
    },
    onRender: function () {
      var self = this;
      self._initializeElements();
      _.delay(function () {
        self._adjustMenuAlignment();
        $(window).on('resize.' + self.cid, _.bind(self._onWindowResize, self));
      }, 50);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
    },
    onChildviewCategoryClicked: function (view, model) {
      var parentSlug;
      var childSlug = model.get('slug');

      var parentModel = this.collection
      .findWhere({ id: model.get('parent_id') });

      if (parentModel == null) {
        parentSlug = childSlug;
        childSlug = 'all';
      } else {
        parentSlug = parentModel.get('slug');
      }

      this.options._appChannel.request(
          'load:category',
          parentSlug,
          childSlug
      );
    }
});
module.exports = CategoryTextMenu;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/category-text-menu.js
 **/